import { computed, reactive, Ref } from "vue";

import { TMonositeMissingInfos } from "@/data/api/kili/consumption/types/monosite-consumption.type";
import { MonositeConsumption } from "@/domains/v4b/site-consumption/monosite-consumption.types";
import { useDashboardStore } from "@/stores/dashboard/dashboard-store";
import { getMaybeTruncatedNumber } from "@/utils/number";

export enum EInsightsCards {
  DSO_PER_AREA_CONSUMPTION = "DSO_PER_AREA_CONSUMPTION",
  CONSUMPTION_EVOLUTION = "CONSUMPTION_EVOLUTION",
  ESTIMATED_CONSUMPTION_COST = "ESTIMATED_CONSUMPTION_COST",
}

export function useInsightsMonoController(
  siteConsumption: Ref<MonositeConsumption | undefined>,
  missingInfos: Ref<TMonositeMissingInfos | undefined>,
) {
  const dashboardStore = useDashboardStore();

  const insightsCardInfosVisible = reactive({
    [EInsightsCards.DSO_PER_AREA_CONSUMPTION]: false,
    [EInsightsCards.CONSUMPTION_EVOLUTION]: false,
    [EInsightsCards.ESTIMATED_CONSUMPTION_COST]: false,
  });

  const devicesConsumptionPercent = computed<number | undefined>(() => {
    if (!siteConsumption.value?.global.value || !siteConsumption.value?.totalDevices.value) return;
    return getMaybeTruncatedNumber(
      (siteConsumption.value.totalDevices.value / siteConsumption.value.global.value) * 100,
    );
  });

  const devicesConsmptionCost = computed<number | undefined>(() => {
    if (!devicesConsumptionPercent.value || !siteConsumption.value?.globalCost.value) return;
    return getMaybeTruncatedNumber((siteConsumption.value?.globalCost.value * devicesConsumptionPercent.value) / 100);
  });

  const averageConsumptionCostPerM2 = computed<number | undefined>(() => {
    if (
      !siteConsumption.value?.global.value ||
      !siteConsumption.value?.globalCost.value ||
      !siteConsumption.value?.totalPerArea.value
    )
      return;
    return getMaybeTruncatedNumber(
      (siteConsumption.value?.totalPerArea.value * siteConsumption.value?.globalCost.value) /
        siteConsumption.value?.global.value,
    );
  });

  function handleShowDsoConsumptionInfos(cardToClose: EInsightsCards) {
    insightsCardInfosVisible[cardToClose] = false;
    dashboardStore.showDsoConsumptionInfos();
  }

  const isMissingDsoSubscriptionWarningVisible = computed<boolean>(() => {
    return (
      !!missingInfos.value?.missingSomeDsoIndexSubscriptions || !!missingInfos.value?.missingAllDsoIndexSubscriptions
    );
  });

  return {
    insightsCardInfosVisible,
    devicesConsumptionPercent,
    devicesConsmptionCost,
    averageConsumptionCostPerM2,
    handleShowDsoConsumptionInfos,
    isMissingDsoSubscriptionWarningVisible,
  };
}
